import { messages } from '@/lib/messages'

const t = messages.documents.editor.template

const NAME_PATTERN = /^[A-Za-z][A-Za-z0-9_]*$/
const RESERVED_NAMES = ['row', 'prev', 'period', 'filters']

/** Sorgu adı için hata metni (geçerliyse tanımsız). */
export function queryNameError(name: string, taken: string[]): string | undefined {
  if (!NAME_PATTERN.test(name) || RESERVED_NAMES.includes(name)) return t.nameInvalid
  if (taken.includes(name)) return t.nameTaken
  return undefined
}
